module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_color_dress-d8413cce6c31b0277a8eda5a0291a542.jpg";